import {
  Badge,
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Divider,
  Flex,
  Grid,
  LoadingOverlay,
  MultiSelect,
  NumberInput,
  Select,
  TextInput,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDebouncedValue, useDisclosure } from "@mantine/hooks";
import { IconArrowBackUp, IconCheck } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  getMasterOrgSelect,
  getProvinceSelectNew,
} from "../../../service/getSelectApi";
import TableProduct from "./TableProduct";

interface TblVourcherDetailslCommand {
  id: number | null;
  vourcherCode: string | null;
  vourcherName: string | null;
  vourcherValue: number | null;
  minOrderAmount: number | null;
  maxOrderAmount: number | null;
  active: boolean;
  startDate: string | Date | null; // hoặc có thể dùng Date nếu muốn
  expiredDate: string | Date | null; // hoặc có thể dùng Date nếu muốn
  voucherQuantity: string | null;
  useForPos: boolean;
  useForWeb: boolean;
  useOneTime: boolean;
  branchIds: string[] | null;
  provinceIds: string | string[] | number[] | null;
  itemCodes: string[] | null;
  segment2CodeStrings: string[] | null;
  segment3CodeStrings: string[] | null;
  segment4CodeStrings: string[] | null;
  applyForFlashSale: boolean;
  applyForNormalPromotion: boolean;
  onlyNewCustomer: boolean;
  maxDiscountAmount: number | null;
  voucherType: string | number | null;
}

const EditView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state && location.state.id;
  const gridSpan2dot4 = { base: 12, md: 6, lg: 2.4 };
  const gridSpan3 = { base: 12, md: 6, lg: 3 };

  const entity = {
    id: 0,
    vourcherCode: null,
    vourcherName: null,
    vourcherValue: null,
    minOrderAmount: null,
    maxOrderAmount: null,
    active: true,
    startDate: new Date(),
    expiredDate: null,
    voucherQuantity: null,
    useForPos: true,
    useForWeb: true,
    useOneTime: false,
    branchIds: [],
    provinceIds: [],
    itemCodes: [],
    segment2CodeStrings: [],
    segment3CodeStrings: [],
    segment4CodeStrings: [],
    applyForFlashSale: false,
    applyForNormalPromotion: false,
    onlyNewCustomer: false,
    maxDiscountAmount: null,
    voucherType: 1,
  };

  const form = useForm<TblVourcherDetailslCommand>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      vourcherCode: (value: string | null) => {
        if (!value || value.length === 0) {
          return "Mã vourcher không được bỏ trống !";
        }
      },
      vourcherName: (value: string | null) => {
        if (!value || value.length === 0) {
          return "Tên vourcher không được bỏ trống !";
        }
      },
      vourcherValue: (value: number | null) => {
        if (!value) {
          return "Giá trị vourcher phải lớn hơn 0 !";
        }
      },
      voucherQuantity: (value: string | null) => {
        if (!value || value.length === 0 || Number(value) <= 0) {
          return "Số lượng vourcher phải lớn hơn 0 !";
        }
      },
      minOrderAmount: (value: number | null, values) => {
        if (!value) {
          return "Giá trị đơn hàng tối thiểu áp dụng phải lớn hơn 0 !";
        }

        if (
          value &&
          values.maxOrderAmount &&
          Number(value) > Number(values.maxOrderAmount)
        ) {
          return "Giá trị đơn hàng tối thiểu áp dụng không được lớn hơn giá trị đơn hàng tối đa được áp dụng !";
        }
      },
      maxOrderAmount: (value: number | null, values) => {
        if (
          value &&
          values.minOrderAmount &&
          Number(value) < Number(values.minOrderAmount)
        ) {
          return "Giá trị đơn hàng tối đa áp dụng không được nhỏ hơn giá trị đơn hàng tối thiểu được áp dụng !";
        }
      },
      startDate: (value: string | Date | null) => {
        if (!value) {
          return "Ngày hiệu lực không được bỏ trống !";
        }
      },
      expiredDate: (value: string | Date | null, values) => {
        if (value && values.startDate) {
          const startDate = new Date(values.startDate);
          const expiredDate = new Date(value);

          if (expiredDate < startDate) {
            return "Ngày hết hiệu lực phải sau ngày hiệu lực !";
          }
        }
      },
      branchIds: (value: string[] | null) => {
        if (!value || value.length === 0) {
          return "Vui lòng chọn chi nhánh áp dụng !";
        }
      },
      maxDiscountAmount: (value: number | null, values) => {
        if (values.voucherType === 2 && !value) {
          return "Tiền giảm tối đa phải lớn hơn 0";
        }
      },
    },
  });

  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataProductSelect, setDataProductSelect] = useState<any[]>([]);
  const [catSegmentSelect, setCatSegmentSelect] = useState<string>("2b");
  const [dataCatSegment2b, setDataCatSegment2b] = useState<any[]>([]);
  const [dataCatSegment3c, setDataCatSegment3c] = useState<any[]>([]);
  const [dataCatSegment4d, setDataCatSegment4d] = useState<any[]>([]);
  const [search4d, setSearch4d] = useState<string>("");
  const [debounceSearch4d] = useDebouncedValue<string>(search4d, 500);
  const [callSuccess, setCallSuccess] = useState<boolean>(false);

  const [visible, { toggle, open, close }] = useDisclosure(false);

  const checkAllElementsExist = () => {
    const branchIds = form.getValues()?.branchIds;
    const dataBranchIdSelect =
      branchIds && Array.isArray(branchIds)
        ? branchIds.map((item) => String(item))
        : [];

    const dataBranch = dataBranchSelect.filter((item) => item.value !== "all");

    if (
      dataBranchIdSelect.length > 0 &&
      dataBranch.length === dataBranchIdSelect.length
    ) {
      return dataBranchIdSelect.every((element) =>
        dataBranch.some((item) => item.value === element.toString()),
      );
    } else {
      return false;
    }
  };

  const getDataBranchSelect = async () => {
    open();
    try {
      const res = await getMasterOrgSelect();

      if (res) {
        const data = res
          ?.filter((item) => item.text && item.value)
          ?.map((item) => ({
            label: `${item.att1} - ${item.text}`,
            value: String(item.value),
          }));
        setDataBranchSelect([{ label: "Tất cả", value: "all" }, ...data]);
        setCallSuccess(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
      setCallSuccess(true);
    }
  };

  const getDataProvinceSelect = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      setDataProvinceSelect(
        res
          ?.filter((item) => item.id && item.name)
          ?.map((item) => ({
            value: String(item.id),
            label: String(item.name),
          })),
      );
    }
  };

  const getCatSegment2b = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment2b/get-all",
    );

    if (res && res.success) {
      const data = res.data?.filter(
        (item: any) => item.codeString && item.name,
      );

      setDataCatSegment2b(data);
    }
  };

  const getCatSegment3c = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment3c/get-all",
    );

    if (res && res.success) {
      const data = res.data?.filter(
        (item: any) => item.codeString && item.name,
      );

      setDataCatSegment3c(data);
    }
  };

  const getCatSegment4d = async () => {
    let url = `/api/v1/TblCatSegment4d/get-list?Skip=0&Take=50`;

    if (debounceSearch4d.length > 2) {
      url += `&KeySearch=${debounceSearch4d}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const data = res.data?.filter(
        (item: any) => item.codeString && item.name,
      );

      setDataCatSegment4d(data);
    }
  };

  const getDataEditVourcher = async () => {
    open();
    try {
      const res = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblVoucherDetail/details?Id=${id}`,
      );

      if (res && res.success) {
        const data = res.data;
        form.setValues(() => ({
          ...data,
          startDate: data.startDate ? new Date(data.startDate ?? "") : null,
          expiredDate: data.expiredDate
            ? new Date(data.expiredDate ?? "")
            : null,
          branchIds: data.branchIds
            ? String(data.branchIds).split(",")
            : dataBranchSelect
                ?.filter((item) => item.value !== "all")
                ?.map((item) => item.value),
          provinceIds: data.provinceIds
            ? String(data.provinceIds).split(",")
            : [],
          segment2CodeStrings: data.segment2CodeStrings
            ? String(data.segment2CodeStrings).split(",")
            : [],
          segment3CodeStrings: data.segment3CodeStrings
            ? String(data.segment3CodeStrings).split(",")
            : [],
          segment4CodeStrings: data.segment4CodeStrings
            ? String(data.segment4CodeStrings).split(",")
            : [],
        }));
        if (data.items && Array.isArray(data.items) && data.items.length > 0) {
          setDataProductSelect(data.items);
        }

        if (data.segment2CodeStrings && data.segment2CodeStrings.length > 0) {
          setCatSegmentSelect("2b");
        } else if (
          data.segment3CodeStrings &&
          data.segment3CodeStrings.length > 0
        ) {
          setCatSegmentSelect("3c");
        } else if (
          data.segment4CodeStrings &&
          data.segment4CodeStrings.length > 0
        ) {
          setCatSegmentSelect("4d");
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleEditVourcher = async (dataSubmit: TblVourcherDetailslCommand) => {
    open();
    try {
      const res = await repositoryPos.put<MessageResponse<any>>(
        "/api/v1/TblVoucherDetail/edit",
        {
          tblVourcherDetailslCommand: {
            ...dataSubmit,
            branchIds: checkAllElementsExist()
              ? []
              : dataSubmit.branchIds &&
                  Array.isArray(dataSubmit.branchIds) &&
                  dataSubmit.branchIds.length > 0
                ? dataSubmit.branchIds?.map((item) => Number(item))
                : [],
            segment2CodeStrings:
              catSegmentSelect === "2b" ? dataSubmit.segment2CodeStrings : [],
            segment3CodeStrings:
              catSegmentSelect === "3c" ? dataSubmit.segment3CodeStrings : [],
            segment4CodeStrings:
              catSegmentSelect === "4d" ? dataSubmit.segment4CodeStrings : [],
          },
        },
      );

      if (res && res.success) {
        NotificationExtension.Success("Chỉnh sửa vourcher thành công !");
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    Promise.all([
      getDataBranchSelect(),
      // getDataProvinceSelect(),
      getCatSegment3c(),
      getCatSegment2b(),
      getCatSegment4d(),
    ]);
  }, []);

  useEffect(() => {
    if (callSuccess) {
      getDataEditVourcher();
    }
  }, [callSuccess]);

  useEffect(() => {
    if (debounceSearch4d.length > 2) {
      getCatSegment4d();
    }
  }, [debounceSearch4d]);

  return (
    <Box
      component="form"
      onSubmit={form.onSubmit((e: TblVourcherDetailslCommand) => {
        handleEditVourcher({
          ...e,
          voucherQuantity: String(e.voucherQuantity),
          startDate: new Date(
            new Date(e.startDate ?? "").getTime() + 7 * 3600 * 1000,
          )?.toISOString(),
          expiredDate: e.expiredDate
            ? new Date(
                new Date(e.expiredDate ?? "").getTime() + 7 * 3600 * 1000,
              )?.toISOString()
            : null,
          provinceIds:
            e.provinceIds &&
            Array.isArray(e.provinceIds) &&
            e.provinceIds.length > 0
              ? e.provinceIds?.map((item) => Number(item))
              : [],
          itemCodes:
            dataProductSelect.length > 0
              ? dataProductSelect?.map((item) => item.itemCode)
              : [],
        });
      })}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
      />
      <Flex justify={"space-between"} align={"center"}>
        <Badge>Chỉnh sửa vourcher</Badge>
        <Flex align={"center"} gap={"md"}>
          <Button
            leftSection={<IconArrowBackUp size={16} />}
            onClick={() => navigate(-1)}
            color="red"
          >
            Thoát
          </Button>
          <Button
            leftSection={<IconCheck size={16} />}
            type="submit"
            loading={visible}
            disabled={visible}
          >
            Lưu
          </Button>
        </Flex>
      </Flex>
      <Grid>
        <Grid.Col span={gridSpan2dot4}>
          <TextInput
            label="Mã vourcher"
            placeholder="Nhập mã voucher"
            value={form.getValues()?.vourcherCode}
            size="xs"
            variant="filled"
            readOnly
            {...form.getInputProps("vourcherCode")}
          />
        </Grid.Col>
        <Grid.Col span={gridSpan2dot4}>
          <TextInput
            key={form.key("vourcherName")}
            label="Tên vourcher"
            placeholder="Nhập tên voucher"
            variant="filled"
            readOnly
            size="xs"
            {...form.getInputProps("vourcherName")}
          />
        </Grid.Col>
        <Grid.Col span={gridSpan2dot4}>
          <Select
            label="Loại vourcher"
            placeholder="Chọn loại vourcher"
            data={[
              { label: "Giảm giá tiền mặt", value: "1" },
              { label: "Giảm theo %", value: "2" },
              // { label: "Freeship", value: "3" },
            ]}
            value={
              form.getValues().voucherType &&
              String(form.getValues().voucherType)
                ? String(form.getValues().voucherType)
                : ""
            }
            size="xs"
            variant="filled"
            readOnly
            {...form.getInputProps("vourcherType")}
            onChange={(e) =>
              form.setValues((prev) => ({
                ...prev,
                voucherType: e ? Number(e) : 1,
                vourcherValue: null,
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={gridSpan2dot4}>
          <NumberInput
            key={form.key("vourcherValue")}
            label="Giá trị vourcher"
            placeholder="Nhập giá trị voucher"
            hideControls
            allowNegative={false}
            thousandSeparator=","
            suffix={
              String(form.getValues().voucherType) === "2"
                ? " %"
                : String(form.getValues().voucherType) === "1"
                  ? " VNĐ"
                  : ""
            }
            variant="filled"
            readOnly
            size="xs"
            {...form.getInputProps("vourcherValue")}
          />
        </Grid.Col>
        {String(form.getValues().voucherType) === "2" ? (
          <Grid.Col span={gridSpan2dot4}>
            <NumberInput
              key={form.key("maxDiscountAmount")}
              label="Tiền giảm tối đa"
              placeholder="Nhập tiền giảm tối đa"
              size="xs"
              hideControls
              allowNegative={false}
              thousandSeparator=","
              min={0}
              suffix=" VNĐ"
              variant="filled"
              readOnly
              {...form.getInputProps("maxDiscountAmount")}
            />
          </Grid.Col>
        ) : (
          <></>
        )}
        <Grid.Col span={gridSpan2dot4}>
          {form.getValues()?.voucherQuantity === "n" ? (
            <TextInput
              label="Số lượng vourcher"
              value={"Không giới hạn"}
              variant="filled"
              readOnly
              size="xs"
            />
          ) : (
            <NumberInput
              key={form.key("voucherQuantity")}
              label="Số lượng vourcher"
              placeholder="Nhập số lượng voucher"
              hideControls
              allowNegative={false}
              thousandSeparator=","
              min={0}
              variant="filled"
              readOnly
              size="xs"
              {...form.getInputProps("voucherQuantity")}
            />
          )}
        </Grid.Col>
        <Grid.Col
          span={
            String(form.getValues().voucherType) === "2"
              ? gridSpan2dot4
              : gridSpan3
          }
        >
          <NumberInput
            key={form.key("minOrderAmount")}
            label="Giá trị đơn hàng tối thiểu được áp dụng"
            placeholder="Nhập giá trị"
            hideControls
            allowNegative={false}
            thousandSeparator=","
            min={0}
            suffix=" VNĐ"
            variant="filled"
            readOnly
            size="xs"
            {...form.getInputProps("minOrderAmount")}
          />
        </Grid.Col>
        <Grid.Col
          span={
            String(form.getValues().voucherType) === "2"
              ? gridSpan2dot4
              : gridSpan3
          }
        >
          <NumberInput
            key={form.key("maxOrderAmount")}
            label="Giá trị đơn hàng tối đa được áp dụng"
            placeholder="Nhập giá trị"
            hideControls
            allowNegative={false}
            thousandSeparator=","
            min={0}
            suffix=" VNĐ"
            {...form.getInputProps("maxOrderAmount")}
            variant="filled"
            readOnly
            size="xs"
          />
        </Grid.Col>
        <Grid.Col
          span={
            String(form.getValues().voucherType) === "2"
              ? gridSpan2dot4
              : gridSpan3
          }
        >
          <DateTimePicker
            key={form.key("startDate")}
            label={"Ngày hiệu lực"}
            placeholder="Nhập ngày bắt đầu hiệu lực"
            withAsterisk
            size="xs"
            {...form.getInputProps("startDate")}
          />
        </Grid.Col>
        <Grid.Col
          span={
            String(form.getValues().voucherType) === "2"
              ? gridSpan2dot4
              : gridSpan3
          }
        >
          <DateTimePicker
            key={form.key("expiredDate")}
            label={"Ngày hết hiệu lực"}
            placeholder="Nhập ngày hết hiệu lực"
            size="xs"
            {...form.getInputProps("expiredDate")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <MultiSelect
            label="Chi nhánh áp dụng"
            placeholder="Nhập chi nhánh áp dụng"
            size="xs"
            data={dataBranchSelect}
            value={
              form.getValues()?.branchIds &&
              Array.isArray(form.getValues()?.branchIds)
                ? form.getValues()?.branchIds
                : []
            }
            searchable
            clearable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            withAsterisk
            disabled={form.getValues().useForWeb}
            {...form.getInputProps("branchIds")}
            onChange={(e) => {
              if (e.includes("all")) {
                form.setFieldValue(
                  "branchIds",
                  dataBranchSelect
                    .filter((item) => item.value !== "all")
                    .map((item) => item.value),
                );
              } else {
                form.setFieldValue("branchIds", e ? e : []);
              }
            }}
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={12}>
          <Flex justify={"space-between"} align={"center"}>
            <Flex align={"center"} gap={"md"}>
              <Checkbox
                label="Hoạt động"
                checked={form.getValues().active}
                size="xs"
                onClick={() =>
                  form.setFieldValue("active", !form.getValues()?.active)
                }
              />
              <Checkbox
                label="Dùng trên POS"
                checked={form.getValues().useForPos}
                size="xs"
                onClick={() =>
                  form.setFieldValue("useForPos", !form.getValues()?.useForPos)
                }
              />
              <Checkbox
                label="Dùng trên Web"
                checked={form.getValues().useForWeb}
                size="xs"
                onClick={() =>
                  form.setValues((prev) => ({
                    ...prev,
                    useForWeb: !form.getValues()?.useForWeb,
                    branchIds: dataBranchSelect
                      .filter((item) => item.value !== "all")
                      .map((item) => item.value),
                  }))
                }
              />
              <Checkbox
                label="Áp dụng flashSale, giờ vàng, ngày vàng"
                checked={form.getValues().applyForFlashSale}
                size="xs"
                onClick={() =>
                  form.setFieldValue(
                    "applyForFlashSale",
                    !form.getValues().applyForFlashSale,
                  )
                }
              />
              <Checkbox
                label="Áp dụng đồng thời CTKM khác"
                checked={form.getValues().applyForNormalPromotion}
                size="xs"
                onClick={() =>
                  form.setFieldValue(
                    "applyForNormalPromotion",
                    !form.getValues().applyForNormalPromotion,
                  )
                }
              />
              <Checkbox
                label="Chỉ được áp dụng 1 voucher/1 KH"
                checked={form.getValues().useOneTime}
                size="xs"
                onClick={() =>
                  form.setFieldValue(
                    "useOneTime",
                    !form.getValues()?.useOneTime,
                  )
                }
              />
              <Checkbox
                label="Chỉ áp dụng cho khách hàng mua lần đầu"
                checked={form.getValues().onlyNewCustomer}
                size="xs"
                onClick={() =>
                  form.setFieldValue(
                    "onlyNewCustomer",
                    !form.getValues().onlyNewCustomer,
                  )
                }
              />
            </Flex>
          </Flex>
        </Grid.Col>
      </Grid>
      <Divider label="Sản phẩm áp dụng" labelPosition="center" />
      <Grid>
        <Grid.Col span={3}>
          <Select
            label="Phân loại"
            placeholder="Chọn phân loại"
            size="xs"
            data={[
              { label: "Ngành hàng", value: "2b" },
              { label: "Loại hàng", value: "3c" },
              { label: "Chủng hàng", value: "4d" },
            ]}
            value={catSegmentSelect}
            onChange={(e) => setCatSegmentSelect(e ? e : "2b")}
            disabled={dataProductSelect.length > 0}
          />
        </Grid.Col>
        {catSegmentSelect === "2b" ? (
          <Grid.Col span={9}>
            <MultiSelect
              label="Ngành hàng áp dụng"
              placeholder="Nhập ngành hàng áp dụng"
              data={dataCatSegment2b?.map((item: any) => ({
                label: `${item.codeString} - ${item.name}`,
                value: item.codeString?.toString(),
              }))}
              size="xs"
              value={
                form.getValues()?.segment2CodeStrings &&
                Array.isArray(form.getValues()?.segment2CodeStrings)
                  ? form.getValues()?.segment2CodeStrings
                  : []
              }
              disabled={dataProductSelect.length > 0}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              {...form.getInputProps("segment2CodeStrings")}
              onChange={(e) => {
                form.setValues((prev) => ({
                  ...prev,
                  segment2CodeStrings: e ? e : [],
                }));
              }}
            />
          </Grid.Col>
        ) : catSegmentSelect === "3c" ? (
          <Grid.Col span={9}>
            <MultiSelect
              label="Loại hàng áp dụng"
              placeholder="Nhập loại hàng áp dụng"
              data={dataCatSegment3c?.map((item: any) => ({
                label: `${item.codeString} - ${item.name}`,
                value: item.codeString?.toString(),
              }))}
              size="xs"
              value={
                form.getValues()?.segment3CodeStrings &&
                Array.isArray(form.getValues()?.segment3CodeStrings)
                  ? form.getValues()?.segment3CodeStrings
                  : []
              }
              disabled={dataProductSelect.length > 0}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              {...form.getInputProps("segment3CodeStrings")}
              onChange={(e) => {
                form.setValues((prev) => ({
                  ...prev,
                  segment3CodeStrings: e ? e : [],
                }));
              }}
            />
          </Grid.Col>
        ) : (
          <Grid.Col span={9}>
            <MultiSelect
              label="Chủng hàng áp dụng"
              placeholder="Nhập chủng hàng áp dụng"
              data={dataCatSegment4d?.map((item: any) => ({
                label: `${item.codeString} - ${item.name}`,
                value: item.codeString?.toString(),
              }))}
              size="xs"
              value={
                form.getValues()?.segment4CodeStrings &&
                Array.isArray(form.getValues()?.segment4CodeStrings)
                  ? form.getValues()?.segment4CodeStrings
                  : []
              }
              searchable
              clearable
              searchValue={search4d}
              onSearchChange={setSearch4d}
              disabled={dataProductSelect.length > 0}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              {...form.getInputProps("segment4CodeStrings")}
              onChange={(e) => {
                form.setValues((prev) => ({
                  ...prev,
                  segment4CodeStrings: e ? e : [],
                }));
              }}
            />
          </Grid.Col>
        )}
      </Grid>
      <Divider mt="xs" label="hoặc" labelPosition="center" />
      <Grid>
        <Grid.Col span={12}>
          <TableProduct
            dataProductSelect={dataProductSelect}
            selectData={setDataProductSelect}
            isEnable={
              (catSegmentSelect === "2b" &&
                (form.getValues().segment2CodeStrings?.length ?? 0) > 0) ||
              (catSegmentSelect === "3c" &&
                (form.getValues().segment3CodeStrings?.length ?? 0) > 0) ||
              (catSegmentSelect === "4d" &&
                (form.getValues().segment4CodeStrings?.length ?? 0) > 0)
            }
          />
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default EditView;
